export default __webpack_public_path__ + "static/media/vedioplay.ac421069.svg";